<template>
  <b-modal title="Szczegóły" v-model="showModal" @hidden="$emit('cancel')">
    <p>
      <b>Pracownik:</b>
      
      <router-link
        :to="{ name: 'employee', params: { id: event.user.id } }"
      >&nbsp;{{ event.user.firstName }} {{ event.user.lastName }}</router-link>
    </p>
    
    <p>
      <b>Planowany urlop:</b>
    
      <span v-if="timeStart && timeEnd">
        <span class="ml-1">{{ dateStart | moment('DD.MM.YYYY') }}</span>
    
        <span class="ml-1">{{ timeStart }} - {{ timeEnd }}</span>
      </span>
    
      <span v-else>
        <span class="ml-1">{{ dateStart | moment('DD.MM.YYYY') }}</span>
    
        <span v-if="dateStart !== dateEnd">- {{ dateEnd | moment('DD.MM.YYYY') }}</span>
      </span>
    </p>

    <p>
      <b>Powód nieobecności:</b>
    
      <span class="ml-1 break-all">{{ reason }}</span>
    </p>

    <p v-if="$is('admin', 'hr')">
      <b>Rodzaj nieobecności:</b>
    
      <span class="ml-1 break-all">{{ selectedAbsence ? selectedAbsence.text : 'Nie wybrano' }}</span>
    </p>

    <div slot="modal-footer">
      <button v-if="!isAccepted && $is('admin', 'manager', 'hr')" class="btn btn-primary mx-1" @click="$emit('edit', event)">Edytuj</button>
    
      <button class="btn btn-secondary mx-1" @click="$emit('cancel')">Anuluj</button>
    
      <button
        v-if="$is('manager', 'admin')"
        class="btn btn-danger mx-1"
        @click="$emit('deny', event)"
      >Odrzuć</button>
    
      <button
        v-if="!$is('admin', 'manager', 'hr')"
        class="btn btn-danger mx-1"
        @click="$emit('deny', event)"
      >Wycofaj wniosek</button>
      
      <button
        v-b-tooltip.hover
        title="Akceptuj rodzaj nieobecności"
        v-if="$is('admin', 'hr') && !event.hrAccept && selectedAbsence"
        class="btn btn-success mx-1"
        @click="selectedAbsence ? $emit('absence', event, selectedAbsence.value) : $emit('absence', event, selectedAbsence)"
      >Akceptuj RN</button>

      <button
        v-b-tooltip.hover
        title="Akceptuj dzień wolny"
        v-if="$is('admin', 'manager') && !event.accepted"
        class="btn btn-success mx-1"
        @click="$emit('accept', event)"
      >Akceptuj DW</button>
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment';
import { toClock } from '@/utils';
import { AbsenceResource } from '@/resources/absence.resource';

export default {
  props: {
    event: Object,
    show: Boolean,
    isAccepted: Boolean
  },
  beforeMount() {
    this.getAbsences();
    this.showModal = this.show;
    if (this.event) {
      const dates = this.event.items.map(item => moment(item.date));
      this.dateStart = moment.min(dates);
      this.dateEnd = moment.max(dates);
      this.reason = this.event.reason;
    }
  },
  data() {
    return {
      showModal: false,
      absences: [],
      selectedAbsence: null
    };
  },
  methods: {
    async getAbsences() {
      const absences = await AbsenceResource.list();
      this.$set(this, 'absences', absences.map(item => ({ value: item.id, text: item.name })));
      if (this.event) {
        this.$set(this, 'selectedAbsence', this.absences.find(e => e.value === this.event.absenceId));
      }
    }
  },
  computed: {
    timeStart() {
      if (this.event.hourStart && this.event.hourEnd) {
        const { hourStart, minuteStart } = this.event;
        return `${toClock(hourStart)}:${toClock(minuteStart || 0)}`;
      }
    },
    timeEnd() {
      if (this.event.hourStart && this.event.hourEnd) {
        const { hourEnd, minuteEnd } = this.event;
        return `${toClock(hourEnd)}:${toClock(minuteEnd || 0)}`;
      }
    }
  }
};
</script>
